export default {
    translation: {
        breadcrumbs: {
            '404': '404',
            '500': '500',
            'app': 'App',
            'horizontal': 'Vízszintes',
            'horizontalMenu': 'vízszintes menü',
            'general': 'Tábornok',
            'component': 'Összetevő',
            'features': 'Jellemzők',
            'applications': 'Alkalmazások',
            'dashboard': 'Irányítópult',
            'dashboard1': 'Irányítópult 1',
            'dashboard2': 'Irányítópult 2',
            'dashboard3': 'Műszerfal 3',
            'modules': 'modulok',
            'agency': 'Ügynökség',
            'pages': 'Oldalak',
            'gallery': 'Képtár',
            'pricing': 'Árazás',
            'terms&Conditions': 'Felhasználási feltételek',
            'feedback': 'Visszacsatolás',
            'report': 'Jelentés',
            'faq(s)': 'FAQ (s)',
            'advancedComponent': 'Előzetes komponens',
            'blank': 'Üres',
            'session': 'Ülés',
            'login': 'Belépés',
            'register': 'Regisztráció',
            'lockScreen': 'Zárolás képernyő',
            'forgotPassword': 'Elfelejtett jelszó',
            'uiComponents': 'UI összetevők',
            'alerts': 'figyelmeztetések',
            'appBar': 'App Bar',
            'avatars': 'karakterekkel',
            'buttons': 'gombok',
            'bottomNavigations': 'Alsó navigáció',
            'badges': 'Kitűzők',
            'cards': 'kártyák',
            'cardsMasonry': 'Kártyák Masonary',
            'chip': 'csip',
            'dialog': 'Párbeszéd',
            'dividers': 'mérőkörző',
            'drawers': 'fiókok',
            'popover': 'Popover',
            'expansionPanel': 'Bővítőpanel',
            'gridList': 'Rácslista',
            'list': 'Lista',
            'menu': 'Menü',
            'popoverAndToolTip': 'Pop Over & ToolTip',
            'progress': 'Előrehalad',
            'snackbar': 'snackbár',
            'selectionControls': 'Kiválasztás vezérlők',
            'advanceUiComponents': 'Advance UI Components',
            'dateAndTimePicker': 'Dátum és időválasztó',
            'tabs': 'Lapok',
            'stepper': 'Stepper',
            'notification': 'Bejelentés',
            'sweetAlert': 'Édes figyelmeztetés',
            'autoComplete': 'Auto Complete',
            'aboutUs': 'Rólunk',
            'widgets': 'Widgets',
            'forms': 'Forms',
            'formElements': 'Form Elemek',
            'textField': 'Szövegmező',
            'selectList': 'Válasszon listát',
            'charts': 'táblázatok',
            'reCharts': 'Re diagramok',
            'reactChartjs2': 'Reagálja a Chartákat 2',
            'icons': 'Ikonok',
            'themifyIcons': 'Themify ikonok',
            'simpleLineIcons': 'Egyszerű vonalikonok',
            'materialIcons': 'Anyag Ikonok',
            'fontAwesome': 'Betűtípus Fantasztikus',
            'tables': 'asztalok',
            'basic': 'Alapvető',
            'dataTable': 'Adattábla',
            'responsive': 'Fogékony',
            'reactTable': 'React táblázat',
            'maps': 'Maps',
            'googleMaps': 'Google térkép',
            'leafletMaps': 'Leaflet Térképek',
            'inbox': 'Bejövő',
            'users': 'felhasználók',
            'userProfile1': 'Felhasználói profil 1',
            'userProfile2': 'Felhasználói profil 2',
            'userManagement': 'Felhasználói menedzsment',
            'userProfile': 'Felhasználói profil',
            'userList': 'Felhasználói lista',
            'calendar': 'Naptár',
            'cultures': 'kultúrák',
            'dnd': 'dnd',
            'selectable': 'választható',
            'customRendering': 'Egyéni renderelés',
            'chat': 'Csevegés',
            'toDo': 'Csinálni',
            'editor': 'Szerkesztő',
            'wysiwygEditor': 'WYSIWYG szerkesztő',
            'quillEditor': 'Quill szerkesztő',
            'reactAce': 'React Ace',
            'dragAndDrop': 'Drag and Drop',
            'reactDragula': 'Reagálj Dragulát',
            'reactDnd': 'React Dnd',
            'blogManagement': 'Blogkezelés',
            'ecommerce': 'E-kereskedelem',
            'shopList': 'Shop lista',
            'shopGrid': 'Shop Rács',
            'invoice': 'Számla',
            'multilevel': 'többszintű',
            'sublevel': 'szintalatti',
            'dateTimePicker': 'Dátum és időválasztó',
            'user': 'használó',
            'miscellaneous': 'Vegyes',
            'promo': 'Promo',
            'gettingStarted': 'Elkezdeni',
            'shop': 'Üzlet',
            'cart': 'kocsi',
            'checkout': 'kijelentkezés',
            'saas': 'SAAS',
            'multiLevel': 'többszintű',
            'level1': '1. szint',
            'level2': '2. szint',
            'boxed': 'Dobozban',
            'news': 'hírek',
            'extensions': 'Extensions',
            'imageCropper': 'Kép Cropper',
            'videoPlayer': 'Videó lejátszó',
            'dropzone': 'Dropzone',
            'crm': 'CRM',
            'projects': 'projektek',
            'projectDetail': 'project részletek',
            'clients': 'ügyfelek',
            'reports': 'jelentések'
        },
        'widgets': {
            'totalEarns': 'Összes keres',
            'emailsStatistics': 'E-mailek statisztikái',
            'totalRevenue': 'Összes bevétel',
            'onlineVistors': 'Online Vistors',
            'trafficSources': 'Forgalomforrások',
            'RecentOrders': 'legutóbbi rendelések',
            'topSellings': 'Legjobb eladások',
            'productReports': 'Termékjelentések',
            'productStats': 'Termékstatisztikák',
            'ComposeEmail': 'E-mail írása',
            'employeePayroll': 'Munkavállalói bérszámfejtés',
            'visitors': 'Látogatók',
            'orders': 'rendelés',
            'orderStatus': 'Rendelés állapota',
            'totalSales': 'Teljes értékesítés',
            'ratings': 'Értékelések',
            'netProfit': 'Nettó nyereség',
            'overallTrafficStatus': 'Átfogó forgalmi állapot',
            'tax': 'Adó',
            'expenses': 'Költségek',
            'currentTime': 'Aktuális idő',
            'currentDate': 'Mostani dátum',
            'todayOrders': 'Ma megrendel',
            'toDoList': 'To Do Lists',
            'discoverPeople': 'Fedezze fel az embereket',
            'commments': 'Hozzászólások',
            'newCustomers': 'új vásárlók',
            'recentNotifications': 'Legutóbbi értesítések',
            'appNotifications': 'Alkalmazás értesítések',
            'newEmails': 'Új e-mailek',
            'siteVisitors': 'Látogatók webhelye',
            'socialCompanines': 'Szociális társaságok',
            'recentActivities': 'Legutóbbi tevékenységek',
            'recentOrders': 'legutóbbi rendelések',
            'gallery': 'Képtár',
            'pricing': 'Árazás',
            'enterpriseEdition': 'Enterprise Edition',
            'personalEdition': 'Személyes kiadás',
            'teamEdition': 'Team Edition',
            'standard': 'Alapértelmezett',
            'advanced': 'Fejlett',
            'master': 'Fő',
            'Mega': 'Mega',
            'logIn': 'Belépés',
            'signUp': 'Regisztrálj',
            'lockScreen': 'Zárolás képernyő',
            'alertsWithLink': 'Figyelmeztetések a kapcsolattal',
            'additionalContent': 'További tartalom',
            'alertDismiss': 'Riasztás elutasítása',
            'uncontrolledDisableAlerts': 'Figyelmeztetések kikapcsolása tiltva',
            'contexualAlerts': 'Contexuális figyelmeztetések',
            'alertsWithIcons': 'Figyelmeztetések ikonokkal',
            'Simple App Bars': 'Egyszerű app bárok',
            'appBarsWithButtons': 'Alkalmazásbárok gombokkal',
            'imageAvatars': 'Image Avatárok',
            'lettersAvatars': 'Levelek avatarok',
            'iconsAvatars': 'Ikonok Avatarok',
            'flatButtons': 'Lapos gombok',
            'raisedButton': 'Emelt gomb',
            'buttonWithIconAndLabel': 'Gomb ikon és címke',
            'floatingActionButtons': 'Lebegő akciógombok',
            'iconButton': 'Ikon gomb',
            'socialMediaButton': 'Social Media gomb',
            'reactButton': 'Reakt gomb',
            'buttonOutline': 'Gomb körvonal',
            'buttonSize': 'Gomb méret',
            'buttonState': 'Gomb állapot',
            'buttonNavigationWithNoLabel': 'gomb Navigáció nem címkével',
            'buttonNavigation': 'Gomb navigáció',
            'iconNavigation': 'Ikon navigáció',
            'badgeWithHeadings': 'Jelvény a fejléccel',
            'contexualVariations': 'Contexuális változatok',
            'badgeLinks': 'Jelvény Linkek',
            'materialBadge': 'Anyag jelvény',
            'simpleCards': 'Egyszerű kártyák',
            'backgroundVarient': 'Háttérvariáns',
            'cardOutline': 'Kártya Vázlat',
            'overlayCard': 'Átfedő kártya',
            'cardGroup': 'Kártya csoport',
            'cardTitle': 'Kártya címe',
            'speacialTitleTreatment': 'Témakörök kezeléset',
            'chipWithClickEvent': 'csip Val vel Kattints esemény',
            'chipArray': 'csip Sor',
            'dialogs': 'dialógusok',
            'listDividers': 'Listaosztók',
            'insetDividers': 'Beilleszkedő oszlopok',
            'temporaryDrawers': 'Ideiglenes fiókok',
            'permanentDrawers': 'Állandó fiókok',
            'simpleExpansionPanel': 'Egyszerű bővítőpanel',
            'controlledAccordion': 'Ellenőrzött harmonika',
            'secondaryHeadingAndColumns': 'Másodlagos cím és oszlopok',
            'imageOnlyGridLists': 'Kép csak rácslista',
            'advancedGridLists': 'Haladó rácslista',
            'singleLineGridLists': 'Egysoros rácslista',
            'simpleLists': 'Egyszerű listák',
            'folderLists': 'Mappa listák',
            'listItemWithImage': 'Listaelem képekkel',
            'switchLists': 'Váltás listák',
            'insetLists': 'Beágyazási listák',
            'nestedLists': 'Beágyazott listák',
            'checkboxListControl': 'jelölőnégyzetet Lista Ellenőrzés',
            'pinedSubHeader': 'pined alfejezet',
            'InteractiveLists': 'Interaktív listák',
            'simpleMenus': 'Egyszerű menük',
            'selectedMenu': 'Kiválasztott menü',
            'maxHeightMenu': 'Max Height Menü',
            'changeTransition': 'Átmenet módosítása',
            'paper': 'Papír',
            'anchorPlayGround': 'Horgony Játék Talaj',
            'tooltip': 'ToolTip',
            'positionedToolTips': 'Pozícionált Snackbar',
            'circularProgressBottomStart': 'Kerek előrehaladás a fenékindításhoz',
            'interactiveIntegration': 'Interaktív integráció',
            'determinate': 'Meghatározó',
            'linearProgressLineBar': 'Lineáris haladási vonal',
            'indeterminate': 'Határozatlan',
            'buffer': 'ütköző',
            'query': 'kérdés',
            'transitionControlDirection': 'Átmeneti irányítás',
            'simpleSnackbar': 'Egyszerű snackbár',
            'positionedSnackbar': 'Pozícionált snackbár',
            'contexualColoredSnackbars': 'Contexual színes falatozók',
            'simpleCheckbox': 'Egyszerű jelölőnégyzet',
            'interminateSelection': 'Közbenső kiválasztás',
            'disabledCheckbox': 'Disabled Checkbox',
            'customColorCheckbox': 'Egyedi színű jelölőnégyzet',
            'VerticalStyleCheckbox': 'Függőleges stílus jelölőnégyzet',
            'horizontalStyleCheckbox': 'Horizontális stílus jelölőnégyzet',
            'radioButtons': 'Rádiógombok',
            'disabledRadio': 'Tiltott rádió',
            'withError': 'Hiba',
            'switches': 'Swiches',
            'dateAndTimePicker': 'Dátum és időválasztó',
            'defaultPicker': 'Alapértelmezett választó',
            'timePicker': 'Időmérő',
            'weekPicker': 'Hétválasztó',
            'defaultDatePicker': 'Alapértelmezett dátumválasztó',
            'customPicker': 'Egyéni komissiózó',
            'tabs': 'Lapok',
            'fixedTabs': 'Fix lapok',
            'basicTab': 'Alapvető fül',
            'wrappedLabels': 'Csomagolt címkék',
            'centeredLabels': 'Központosított címkék',
            'forcedScrolledButtons': 'Kényszerített görgetett gombok',
            'iconsTabs': 'Ikonok lapok',
            'withDisableTabs': 'A Letiltás lapok segítségével',
            'iconWithLabel': 'Ikon címkével',
            'stepper': 'Stepper',
            'horizontalLinear': 'Vízszintesen lineáris',
            'horizontalNonLinear': 'Vízszintes nem lineáris',
            'horizontalLinerAlternativeLabel': 'Vízszintes bélés alternatív címke',
            'horizontalNonLinerAlternativeLabel': 'Vízszintes nem liner alternatív címke',
            'verticalStepper': 'Függőleges léptető',
            'descriptionAlert': 'Leírás Figyelmeztetés',
            'customIconAlert': 'Egyéni ikon figyelmeztetés',
            'withHtmlAlert': 'Html figyelmeztetéssel',
            'promptAlert': 'Gyors figyelmeztetés',
            'passwordPromptAlert': 'Jelszó gyors figyelmeztetés',
            'customStyleAlert': 'Egyéni stílus figyelmeztetés',
            'autoComplete': 'Auto Complete',
            'reactSelect': 'Reagál választ',
            'downshiftAutoComplete': 'Lefelé váltás automatikus befejezése',
            'reactAutoSuggests': 'React Auto Javasolja',
            'aboutUs': 'Rólunk',
            'ourVission': 'A mi vádunk',
            'ourMissions': 'Küldetéseink',
            'ourMotivation': 'Motivációnk',
            'defualtReactForm': 'Defualt Reagál Forma',
            'url': 'url',
            'textArea': 'Szövegterület',
            'file': 'fájl',
            'formGrid': 'Forma Rács',
            'inlineForm': 'Inline formanyomtatvány',
            'inputSizing': 'Bemeneti méretezés',
            'inputGridSizing': 'Bemeneti rácsméretezés',
            'hiddenLabels': 'Rejtett címkék',
            'formValidation': 'Forma validálás',
            'number': 'Szám',
            'date': 'Dátum',
            'time': 'Idő',
            'color': 'Szín',
            'search': 'Keresés',
            'selectMultiple': 'Válassza a Többszörös lehetőséget',
            'inputWithSuccess': 'Bevitel sikerrel',
            'inputWithDanger': 'Veszélyes bemenet',
            'simpleTextField': 'Egyszerű szövegmező',
            'componet': 'Alkatrészek',
            'layouts': 'elrendezések',
            'inputAdorements': 'Beviteli kapcsolatok',
            'formattedInputs': 'Formázott bemenetek',
            'simpleSelect': 'Egyszerű választás',
            'nativeSelect': 'Anyanyelvi választ',
            'MutltiSelectList': 'Mutlti választ Lista',
            'lineChart': 'Vonalrajz',
            'barChart': 'Oszlopdiagram',
            'stackedBarChart': 'Halmozott oszlopdiagram',
            'lineBarAreaChart': 'Vonalbár területrajz',
            'areaChart': 'Területi Diagram',
            'stackedAreaChart': 'Halmozott területrajz',
            'verticalChart': 'Függőleges diagram',
            'radarChart': 'Radar diagram',
            'doughnut': 'Fánk',
            'polarChart': 'Polár diagram',
            'pieChart': 'Kördiagram',
            'bubbleChart': 'Buborék Diagram',
            'horizontalBar': 'Horizonatl Bár',
            'basicTable': 'Alapvető táblázat',
            'contexualColoredTable': 'Contexuális színes asztal',
            'dataTable': 'Adattábla',
            'employeeList': 'Munkavállalói lista',
            'responsiveTable': 'Érzékeny tábla',
            'responsiveFlipTable': 'Érzékeny flip táblázat',
            'reactGridControlledStateMode': 'React Grid vezérelt állapot mód',
            'googleMaps': 'Google térkép',
            'productsReports': 'Termékek jelentései',
            'taskList': 'Feladat lista',
            'basicCalender': 'Alapvető naptár',
            'culturesCalender': 'Növénykultúrák',
            'dragAndDropCalender': 'ellenállás és Csepp kalander',
            'selectableCalender': 'Választható naptár',
            'customRendering': 'Egyéni renderelés',
            'customCalender': 'Egyéni naptár',
            'searchMailList': 'Keresés a levéllisták között',
            'forgetPassword': 'Elfelejtett jelszo',
            'QuickLinks': 'Gyors linkek',
            'upgrade': 'frissítés',
            'app': 'App',
            'addNew': 'Új hozzáadása',
            'orderDate': 'Rendelés dátuma',
            'status': 'Állapot',
            'trackingNumber': 'Követési szám',
            'action': 'Akció',
            'designation': 'Kijelölés',
            'subject': 'tantárgy',
            'send': 'Elküld',
            'saveAsDrafts': 'Piszkozatok mentése',
            'onlineSources': 'Online források',
            'lastMonth': 'Múlt hónap',
            'widgets': 'Widgets',
            'listing': 'felsorolás',
            'paid': 'Fizetett',
            'refunded': 'Visszautalva',
            'done': 'Kész',
            'pending': 'Függőben levő',
            'cancelled': 'Törölve',
            'approve': 'Jóváhagy',
            'following': 'Következő',
            'follow': 'kövesse',
            'graphs&Charts': 'Grafikonok és grafikonok',
            'open': 'Nyisd ki',
            'bounced': 'Visszafordulást',
            'spam': 'Levélszemét',
            'unset': 'hatástalanított',
            'bandwidthUse': 'Sávszélesség használata',
            'dataUse': 'Adatok felhasználása',
            'unsubscribe': 'Leiratkozás',
            'profile': 'Profil',
            'messages': 'üzenetek',
            'support': 'Támogatás',
            'faq(s)': 'FAQ (s)',
            'upgradePlains': 'Upgrade Plains',
            'logOut': 'Kijelentkezés',
            'mail': 'Levél',
            'adminTheme': 'Admin témát',
            'wordpressTheme': 'Wordpress téma',
            'addToCart': 'Kosárba',
            'plan': 'Terv',
            'basic': 'Alapvető',
            'pro': 'Pro',
            'startToBasic': 'Indítsa el az alapot',
            'upgradeToPro': 'Frissítés Pro verzióra',
            'upgradeToAdvance': 'Frissítés előre',
            'comparePlans': 'Tervek összehasonlítása',
            'free': 'Ingyenes',
            'frequentlyAskedQuestions': 'Gyakran Ismételt Kérdések',
            'searchIdeas': 'Keresés ötletek',
            'startDate': 'Kezdő dátum',
            'endDate': 'Befejezés dátuma',
            'category': 'Kategória',
            'apply': 'Alkalmaz',
            'downloadPdfReport': 'Pdf jelentés letöltése',
            'yesterday': 'Tegnap',
            'totalOrders': 'Teljes rendelések',
            'totalVisitors': 'Összes látogató',
            'typeYourQuestions': 'Írja be a kérdéseit',
            'username': 'Felhasználónév',
            'password': 'Jelszó',
            'signIn': 'Bejelentkezés',
            'enterYourPassword': 'Írd be a jelszavad',
            'alreadyHavingAccountLogin': 'Már rendelkezik fiók bejelentkezéssel',
            'composeMail': 'Compose Mail',
            'issue': 'Probléma',
            'recentChat': 'Legutóbbi csevegés',
            'previousChat': 'Előző csevegés',
            'all': 'Minden',
            'filters': 'Szűrők',
            'deleted': 'törölve',
            'starred': 'Csillagos',
            'frontend': 'frontend',
            'backend': 'háttér',
            'api': 'Api',
            'simpleAppBar': 'Egyszerű alkalmazássáv',
            'recents': 'Legutóbbiak',
            'cardLink': 'Kártya Link',
            'anotherLink': 'Egy másik link',
            'cardSubtitle': 'kártya felirat',
            'confirmationDialogs': 'Megerősítő párbeszédpanelek',
            'deletableChip': 'Törölhető chip',
            'customDeleteIconChip': 'Egyéni ikon törlése',
            'openAlertDialog': 'Nyílt figyelmeztetés párbeszédablak',
            'openResponsiveDialog': 'Nyissa meg a válaszadó párbeszédablakot',
            'openSimpleDialog': 'Nyissa meg az egyszerű párbeszédablakot',
            'openFormDialog': 'Nyitott űrlap párbeszédablak',
            'follower': 'Követő',
            'important': 'Fontos',
            'private': 'Magán',
            'openLeft': 'Nyissa balra',
            'openRight': 'Jobbra nyílik',
            'openTop': 'Nyitott felső',
            'openBottom': 'Nyisd meg lent',
            'selectTripDestination': 'Válassza az Úticél célállomást',
            'pinnedSubheaderList': 'Pinned Subheader List',
            'singleLineItem': 'Egysoros tétel',
            'acceptTerms': 'Feltételek elfogadása',
            'optionA': 'A lehetőség',
            'optionB': 'B opció',
            'optionC': 'C opció',
            'optionM': 'Opció M',
            'optionN': 'Opció N',
            'optionO': 'Opció O',
            'customColor': 'Egyéni szín',
            'centeredTabs': 'Központosított lapok',
            'multipleTabs': 'Több lap',
            'preventScrolledButtons': 'A görgetett gombok megakadályozása',
            'browse': 'Böngésszen',
            'formValidate': 'Forma Érvényesít',
            'code': 'Kód',
            'company': 'Vállalat',
            'price': 'Ár',
            'change': 'változás',
            'high': 'Magas',
            'low': 'Alacsony',
            'volume': 'Hangerő',
            'personalDetails': 'Személyes adatok',
            'occupation': 'Foglalkozása',
            'companyName': 'Cégnév',
            'phoneNo': 'Telefonszám',
            'city': 'Város',
            'zipCode': 'Irányítószám',
            'updateProfile': 'Profil frissítése',
            'reject': 'Elutasít',
            'exportToExcel': 'Exportálás Excel-be',
            'addNewUser': 'Új felhasználó hozzáadása',
            'workWeek': 'Munkahét',
            'agenda': 'Napirend',
            'conference': 'konferencia',
            'multilevel': 'többszintű',
            'dailySales': 'Napi értékesítés',
            'today': 'Ma',
            'campaignPerformance': 'Kampány teljesítmény',
            'supportRequest': 'Támogatási kérelem',
            'usersList': 'Felhasználók listája',
            'lastWeek': 'Múlt hét',
            'buyMore': 'Többet vásárolnak',
            'trafficChannel': 'Forgalmi csatorna',
            'stockExchange': 'Tőzsde',
            'tweets': 'Tweets',
            'ourLocations': 'Helyszínek',
            'sales': 'Sales',
            'to': 'Nak nek',
            'shipTo': 'Kiszállítás',
            'description': 'Leírás',
            'unitPrice': 'Egységár',
            'total': 'Teljes',
            'note': 'jegyzet',
            'chipWithAvatar': 'Chip Avatárral',
            'chipWithTextAvatar': 'Chip szöveggel Avatar',
            'chipWithIconAvatar': 'Chip ikonral Avatar',
            'customClickableChip': 'Egyéni Clickable Chip',
            'outlineChip': 'Outline Chip',
            'disableChip': 'Chip letiltása',
            'alertDialog': 'Riasztási párbeszéd',
            'animatedSlideDialogs': 'Animált dia párbeszédek',
            'fullScreenDialogs': 'Teljes képernyős párbeszédek',
            'formDialogs': 'Űrlap párbeszédablakok',
            'simpleDialogs': 'Egyszerű párbeszédek',
            'responsiveFullScreen': 'Érzékeny teljes képernyő',
            'primary': 'Elsődleges',
            'social': 'Társadalmi',
            'user': 'használó',
            'admin': 'admin',
            'permanentdrawer': 'Állandó fiók',
            'persistentdrawer': 'Tartós fiók',
            'swiches': 'Swiches',
            'horizontalLinearAlternativeLabel': 'Vízszintes lineáris alternatív címke',
            'horizontalNonLinearAlternativeLabel': 'vízszintes, nem lineáris alternatív címke',
            'notifications': 'értesítések',
            'basicAlert': 'Alap riasztás',
            'successAlert': 'Sikeres figyelmeztetés',
            'warningAlert': 'Figyelmeztető figyelmeztetés',
            'reactAutoSuggest': 'React Auto Javasolja',
            'components': 'Alkatrészek',
            'inputAdornments': 'Beviteli kapcsolatok',
            'multiSelectList': 'Több kiválasztási lista',
            'contextualColoredTable': 'Contexuális színes asztal',
            'updateYourEmailAddress': 'Frissítse e-mail címét',
            'selectADefaultAddress': 'Válasszon egy alapértelmezett címet',
            'activity': 'Tevékenység',
            'basicCalendar': 'Alapvető naptár',
            'culturesCalendar': 'Kultúrák Naptár',
            'dragAndDropCalendar': 'Húzza és tegye le a naptárat',
            'quillEditor': 'Quill szerkesztő',
            'reactDND': 'Reagálj DND-t',
            'dragula': 'Dragula',
            'AcceptorrRejectWithin': 'Elfogadni vagy elutasítani',
            'quoteOfTheDay': 'A nap idézete',
            'updated10Minago': 'Frissítve 10 perccel ezelőtt',
            'personalSchedule': 'Személyes ütemezés',
            'activeUsers': 'Aktív felhasználók',
            'totalRequest': 'Teljes kérelem',
            'new': 'Új',
            'ShareWithFriends': 'Oszd meg a barátaiddal!',
            'helpToShareText': 'Segítsen elterjeszteni a világot azzal, hogy megosztja weboldalunkat barátainkkal és a közösségi médiában élő követőkkel!',
            'thisWeek': 'Ezen a héten',
            'howWouldYouRateUs': 'Hogyan ítélné meg nekünk?',
            'booking': 'foglalás',
            'confirmed': 'Megerősített',
            'monthly': 'havi',
            'weekly': 'heti',
            'target': 'célpont',
            'totalActiveUsers': 'Összes aktív felhasználó',
            'deadline': 'Határidő',
            'team': 'Csapat',
            'projectManagement': 'Projektmenedzsment',
            'latestPost': 'Utolsó poszt',
            'projectTaskManagement': 'Projekt feladatkezelés',
            'selectProject': 'Válassza ki a Projektet',
            'activityBoard': 'Tevékenységbizottság',
            'checklist': 'Ellenőrző lista',
            'baseConfig': 'Base Config',
            'customControlBar': 'Egyéni vezérlőpult',
            'withDownloadButton': 'Letöltés gombbal',
            'httpLiveStreaming': 'HTTP élő közvetítés',
            'keyboardShortcuts': 'Gyorsbillentyűket',
            'preview': 'Előnézet',
            'croppedImage': 'Vágott kép',
            'transactionList': 'tranzakciós lista',
            'transferReport': 'átutalási jelentés',
            'expenseCategory': 'költségkategória',
            'upcomingEvents': 'Közelgő események',
            'OngoingProjects': 'folyamatban lévő projektek',
            'ProjectStatus': 'Projekt állapota',
            'LiveChatSupport': 'élő chat-támogatás'
        },
        'components': {
            'buyNow': 'Vásárolj most',
            'alreadyHavingAccountSignIn': 'Már bejelentkezve',
            'enterYourPassword': 'Írd be a jelszavad',
            'unlock': 'Kinyit',
            'enterPasswords': 'Adjon meg jelszavakat',
            'resetPassword': 'Jelszó visszavonása',
            'pageNotfound': 'Az oldal nem található',
            'goToHomePage': 'Menj a főoldalra',
            'sorryServerGoesWrong': 'Sajnos a szerver hibás',
            'persistentDrawer': 'Tartós fiók',
            'back': 'Hát',
            'next': 'Következő',
            'completeStep': 'Teljes lépés',
            'withHtml': 'Html-vel',
            'prompt': 'Gyors',
            'withDescription': 'A leírással',
            'success': 'Siker',
            'passwordPrompt': 'Jelszó kérés',
            'warning': 'Figyelem',
            'customIcon': 'Egyéni ikon',
            'customStyle': 'Egyéni stílus',
            'basic': 'Alapvető',
            'submit': 'beküldése',
            'compose': 'Összeállít',
            'sendMessage': 'Üzenet küldése',
            'addNewTasks': 'Új feladatok hozzáadása',
            'addToCart': 'Kosárba',
            'payNow': 'Fizess most',
            'print': 'Nyomtatás',
            'cart': 'kocsi',
            'viewCart': 'Kosár megtekintése',
            'checkout': 'kijelentkezés',
            'summary': 'összefoglalás',
            'last7Days': 'Utolsó 7 nap',
            'last1Month': 'Last 1 Month',
            'last6Month': 'Utolsó 6 hónap',
            'spaceUsed': 'Használt hely',
            'followers': 'követője',
            'trending': 'Felkapott',
            'paid': 'fizetett',
            'refunded': 'Visszautalva',
            'done': 'Kész',
            'pending': 'Függő',
            'cancelled': 'Törölt',
            'approve': 'Jóváhagyás',
            'week': 'Hét',
            'month': 'Hónap',
            'year': 'Year',
            'today': 'Ma',
            'popularity': 'Népszerűség',
            'email': 'Email',
            'drafts': '',
            'sent': 'Küldött',
            'trash': 'Szemét',
            'all': 'Minden',
            'do': 'csinál',
            'title': 'Cím',
            'projectName': 'Projekt neve',
            'companyName': 'Cégnév',
            'openAlert': 'Nyílt figyelmeztetés',
            'slideInAlertDialog': 'Csúsztassa a riasztási párbeszédablakban',
            'openFullScreenDialog': 'Nyissa meg a teljes képernyős párbeszédpanelt',
            'basicChip': 'Alap Chip',
            'clickableChip': 'Clickable Chip',
            'left': 'Balra',
            'right': 'Jobb',
            'expansionPanel1': 'Bővítőpanel 1',
            'expansionPanel2': 'Bővítőpanel 2',
            'generalSetting': 'Általános beállítás',
            'advancedSettings': 'További beállítások',
            'firstName': 'Keresztnév',
            'lastName': 'Vezetéknév',
            'occupation': 'Foglalkozása',
            'phoneNo': 'Telefonszám',
            'address': 'Cím',
            'city': 'Város',
            'state': 'Állapot',
            'zipCode': 'Irányítószám',
            'social Connection': 'Közösségi kapcsolat',
            'emailPrefrences': 'E-mail beállítások',
            'myProfile': 'A profilom',
            'product': 'Termék',
            'quantity': 'Mennyiség',
            'totalPrice': 'Teljes ár',
            'removeProduct': 'Termék eltávolítása',
            'mobileNumber': 'Mobil szám',
            'address2Optional': '2. cím (opcionális)',
            'country': 'Ország',
            'zip': 'Postai irányítószám',
            'saveContinue': 'Mentés és folytatás',
            'placeOrder': 'Rendelés',
            'payment': 'Fizetés',
            'billingAddress': 'számlázási cím',
            'ShippingAddressText': 'A szállítási cím ugyanaz, mint a számlázási cím.',
            'CartEmptyText': 'Az Ön kosara üres!',
            'NoItemFound': 'Nincs találat',
            'goToShop': 'Boltba menni',
            'cardNumber': 'Kártyaszám',
            'expiryDate': 'Lejárati dátum',
            'cvv': 'CVV',
            'nameOnCard': 'A kártyán szereplő név',
            'confirmPayment': 'Fizetés megerősítése'
        },
        'compenets': {
            'choose': 'Választ',
            'username': 'Felhasználónév',
            'passwords': 'jelszavak',
            'signIn': 'Bejelentkezés',
            'dontHaveAccountSignUp': 'Dont Have Account SignUp',
            'enterUserName': 'Adja meg a felhasználónevet',
            'enterEmailAddress': 'Adja meg az email címét',
            'confirmPasswords': 'Jelszavak megerősítése'
        },
        'themeOptions': {
            'sidebarOverlay': 'Sidebar Overlay',
            'sidebarBackgroundImages': 'Oldalsáv háttérképek',
            'appSettings': 'Alkalmazásbeállítások',
            'sidebarImage': 'Oldalsáv kép',
            'miniSidebar': 'Mini Sidebar',
            'boxLayout': 'Doboz elrendezés',
            'rtlLayout': 'Rtl elrendezés',
            'darkMode': 'Sötét mód',
            'sidebarLight': 'Fény',
            'sidebarDark': 'Sötét',
            'themeColor': 'Téma Szín'
        },
        'button': {
            'cancel': 'Megszünteti',
            'add': 'hozzáad',
            'update': 'frissítés',
            'reply': 'Válasz',
            'delete': 'Töröl',
            'yes': 'Igen',
            'viewAll': 'Összes megtekintése',
            'like': 'Mint',
            'assignNow': 'Hozzárendelés most',
            'seeInsights': 'Tekintse meg a Insights elemet',
            'acceptTerms': 'Feltételek elfogadása',
            'reject': 'Elutasít',
            'addNew': 'Új hozzáadása',
            'goToCampaign': 'Menjen a kampányba',
            'viewProfile': 'Profil megtekintése',
            'sendMessage': 'Üzenet küldése',
            'saveNow': 'Ments most',
            'pen': 'Toll',
            'search': 'Keresés',
            'downloadPdfReport': 'Pdf jelentés letöltése',
            'primary': 'Elsődleges',
            'secondary': 'Másodlagos',
            'danger': 'Veszély',
            'info': 'Info',
            'success': 'Siker',
            'warning': 'Figyelem',
            'link': 'Link',
            'smallButton': 'Kis gomb',
            'largeButton': 'Nagy gomb',
            'blockLevelButton': 'Blokkszintű gomb',
            'primaryButton': 'Elsődleges gomb',
            'button': 'Gomb',
            'save': 'Mentés',
            'openMenu': 'Nyisd ki Menü',
            'openWithFadeTransition': 'Nyitott a halványodás átmenetével',
            'openPopover': 'Nyissa meg a Popover lehetőséget',
            'accept': 'Elfogad',
            'click': 'Kattints',
            'complete': 'teljes',
            'back': 'Hát',
            'next': 'Következő',
            'completeStep': 'Teljes lépés',
            'error': 'Hiba',
            'writeNewMessage': 'Új üzenet írása',
            'saveChanges': 'Változtatások mentése',
            'addNewUser': 'Új felhasználó hozzáadása',
            'more': 'Több',
            'useDefaultImage': 'Alapértelmezett kép használata',
            'cropImage': 'Crop kép'
        },
        'hint': {
            'whatAreYouLookingFor': 'Mit keresel',
            'searchMailList': 'Keresés a levéllisták között'
        },
        'module': {
            'inbox': 'Bejövő',
            'drafts': '',
            'sent': 'Küldött',
            'trash': 'Szemét',
            'spam': 'Levélszemét',
            'frontend': 'Frontend',
            'backend': 'háttér',
            'api': 'Api',
            'issue': 'Probléma'
        },
        'documents': {},
        'common': {},
        'logout': {},
        'login': {},
        'actions': {},
        'sign_up': {},
        'Widgets': {
            'listing': 'lista'
        },
        'Components': {
            'yesterday': 'Yesterday'
        }
    }
};
